export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/gig_page_perseus/audio_preview.479f0d5.png";